import { useLocation, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { AlertCircle } from "lucide-react";
import { SEO } from "@/components/SEO";
import { findCaseStudyBySlug } from "@/data/caseStudiesData";
import { buildCaseStudySchema } from "@/data/advancedSchemas";
import { getRelatedContent } from "@/data/relatedContent";
import { GenericHero } from "@/components/content/Hero";
import { CaseInfoBlock } from "@/components/content/CaseInfo";
import { SectionsBlock } from "@/components/content/Sections";
import { FaqBlock } from "@/components/content/Faq";
import { CtaBlock } from "@/components/content/Cta";
import { RelatedContentBlock } from "@/components/content/RelatedContent";

export default function CaseStudyPage() {
  const { pathname } = useLocation();
  const slug = pathname.replace(/^\/etudes-de-cas\//, "");
  const study = findCaseStudyBySlug(slug);

  if (!study) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-center px-4">
          <AlertCircle className="h-16 w-16 text-red-600 mx-auto mb-4" />
          <h1 className="text-3xl font-bold mb-4">Étude de cas introuvable</h1>
          <Link to="/etudes-de-cas">
            <Button>Voir toutes les études</Button>
          </Link>
        </div>
      </div>
    );
  }

  const schema = buildCaseStudySchema(study);
  const description = study.metaDescription;
  const keywords = `${study.keyword}, étude de cas ${study.category}, ${study.title.toLowerCase()}, Mediastore Niort, ${study.caseDetails?.device || ""}`;
  const breadcrumbs = [
    { name: "Accueil", path: "/" },
    { name: "Études de cas", path: "/etudes-de-cas" },
    { name: study.title, path: `/etudes-de-cas/${study.slug}` },
  ];

  return (
    <div className="min-h-screen" data-testid="case-study-page">
      <SEO
        title={study.metaTitle}
        description={description}
        keywords={keywords}
        path={`/etudes-de-cas/${study.slug}`}
        schema={schema}
        breadcrumbs={breadcrumbs}
        type="article"
        publishedTime={study.publishedDate}
        modifiedTime="2026-02-10"
      />

      <GenericHero
        category={study.category}
        badge="Étude de cas réelle"
        title={study.title}
        intro={study.intro}
        iconName={study.icon}
        accentColor="emerald"
      />
      <CaseInfoBlock caseDetails={study.caseDetails} />
      {study.sections && study.sections.length > 0 && <SectionsBlock sections={study.sections} />}
      <FaqBlock faqs={study.faqs} />
      <RelatedContentBlock items={getRelatedContent(study, "case")} />
      <CtaBlock relatedSlugs={study.relatedSlugs} />
    </div>
  );
}
